<template>
  <div class="deviation-request-assign-to-button">
    <button type="button" ref="assignToButton" class="btn btn-warning" click.delegate="showOptions = !showOptions">
      <i class="fas fa-user-check"></i><span class="d-none d-lg-inline-block ml-1">Assign</span>
    </button>
    <ul show.bind="showOptions">
      <li repeat.for="item of items" click.delegate="itemClicked(item)">
        ${ item.name }
      </li>
    </ul>
  </div>
</template>
